// extracted by mini-css-extract-plugin
export default {"cultureImageGrid":"cultureImageGrid-uif1W","thumbnailContainer":"thumbnailContainer-etwKY","thumbnail":"thumbnail-XiZqs","thumbnailCaption":"thumbnailCaption-SlhR_"};